import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["commissionBidFormWrapper", "commissionBidLimit", "commissionBids", "commissionBidWrapper"]
  static values = { slug: String }

  connect() {
    if (this.slugValue) {
      this.dispatch("connect", { detail: { webcastLot: this } })
    }
  }

  displayElements(limit) {
    if (this.hasCommissionBidFormWrapperTarget) {
      this.#showTarget(this.commissionBidFormWrapperTarget)
    }

    if (limit) {
      this.#showTarget(this.commissionBidWrapperTarget)
      this.commissionBidLimitTarget.textContent = limit
    }
  }

  commissionBidsTargetConnected(target) {
    const commissionBids = JSON.parse(target.dataset.json)

    this.displayElements(commissionBids[this.slugValue])
    this.dispatch("commissionBidsUpdate", { detail: { commissionBids } })
    target.remove()
  }

  #showTarget(target) {
    target.classList.remove(this.hiddenClass)
  }
}
